<template>
    <ErrorList v-if="error" :error="error"/>
    <div v-else>
        <IdleModal v-if="isIdle"/>
        <header id="header">
            <div class="left">
                <template v-if="policiesRetrieved()">
                    <router-link :to="{ name: 'Reporting' }"><img src="/img/on-logo.png" alt="Omaha National"/></router-link>
                </template>
                <template v-else>
                    <img src="/img/on-logo.png" alt="Omaha National"/>
                </template>
            </div>
            <div class="right">
                <div v-if="alternateReportingDate" class="ReportingDate" title="Reporting date">{{ alternateReportingDate }}<font-awesome-icon :icon="['fas', 'calendar-day']"/></div>
                <div class="ContactName" title="User">{{ contact.name }}<font-awesome-icon :icon="['fas', 'user']"/></div>
                <button @click="onLogout()" class="LogoutButton button-lg purple">Log Out</button>
            </div>
        </header>
        <h1 id="banner">{{ title }}</h1>
        <nav id="navigation">
            <template v-if="policiesRetrieved()">
                <router-link active-class="ActiveHeaderLink" :to="{ name: 'Reporting' }">Self-Reporting</router-link>
                <router-link active-class="ActiveHeaderLink" :to="{ name: 'PaymentHistory' }">History</router-link>
                <router-link active-class="ActiveHeaderLink" :to="{ name: 'Instructions' }">Reporting Instructions</router-link>
                <router-link active-class="ActiveHeaderLink" :to="{ name: 'ContactUs' }">Contact Us</router-link>
            </template>
            <template v-else>
                <router-link active-class="ActiveHeaderLink" :to="{ name: 'NoReporting' }">Self-Reporting</router-link>
                <router-link active-class="ActiveHeaderLink" :to="{ name: 'PaymentHistory' }">History</router-link>
                <router-link active-class="ActiveHeaderLink" :to="{ name: 'Instructions' }">Reporting Instructions</router-link>
                <router-link active-class="ActiveHeaderLink" :to="{ name: 'ContactUs' }">Contact Us</router-link>
            </template>
        </nav>
    </div>
</template>

<script>
import { onLogout } from '@/utils/helpers'
import { mapState } from 'vuex'
import IdleModal from "../IdleModal"
import ErrorList from "../shared/ErrorList"
import moment from "moment"

export default {
    name: 'Header',
    props: [ 'title' ],
    components: { IdleModal, ErrorList },
    data() {
        return {
            error: null,
            policyId: null
        }
    },
    methods: {
        onLogout() {
            onLogout(this)
        },
        policiesRetrieved() {
            return this.policies.length > 0
        },
        isMultiplePolicy() {
            return this.policies.length > 1
        },
        show() {
            this.$store.dispatch('isVisible', true)
                .catch((error) => {
                    this.error = error
                })
        }
    },
    computed: {
        ...mapState([ 'contact', 'policies', 'reporting' ]),
        isIdle() {
            return this.$store.state.idleVue.isIdle
        },
        alternateReportingDate() {
            if (this.reporting.reportingDate) {
                const today = moment(Date.now()).format('YYYY-MM-DD')
                const reportingDate = moment(this.reporting.reportingDate).format('YYYY-MM-DD')

                if (today !== reportingDate) {
                    return moment(reportingDate).format('MM/DD/YYYY');
                }
            }
        }
    }
}
</script>
